import React, { useContext, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { ThemeContext, ThemeProvider } from "./components/ThemeContext";
import HeaderWithStyles from "./components/Header";
import Footer from "./components/Footer";
import PageLayout from "./components/PageLayout";
import HeaderSmallWithStyles from "./components/HeaderSmall";
import ContactForm from "./components/ContactForm";
import AISidebar from "./components/AISidebar";
import footerAv from './assets/footer (2).png';
import { motion } from "framer-motion";
import { SmoothScrollProvider } from "./components/SmoothScrollProvider";

const AppLayout = () => {
  const { isLight } = useContext(ThemeContext);
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <SmoothScrollProvider>
      <div className={`${isLight ? "" : "dark"} relative overflow-hidden`}>
        <HeaderWithStyles
          onLetsTalk={() => setIsAISidebarOpen(true)}
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
          isAISidebarOpen={isAISidebarOpen}
        /> {/* Header */}
        <HeaderSmallWithStyles
          onLetsTalk={() => setIsAISidebarOpen(true)}
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
          isAISidebarOpen={isAISidebarOpen}
        /> {/* Header */}

        <Outlet context={{ isMenuOpen }} />
        <ContactForm />        {/* Content goes here */}
        <Footer />

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="w-full text-center lg:mt-2 mt-1.5 lg:mb-2 mb-1.5 lg:text-xl text-lg font-medium text-zinc-700 dark:text-zinc-200 flex md:flex-row flex-col items-center justify-center gap-2"
        >
          Designed and developed with
          <motion.span
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
            role="img"
            aria-label="heart"
            className="mx-1 text-red-500"
          >
            <img src={footerAv} className="lg:w-14 w-10" />
          </motion.span>
          <span className="font-semibold text-zinc-700 dark:text-zinc-200"> by  me</span>
        </motion.div>

        <AISidebar isOpen={isAISidebarOpen} onClose={() => setIsAISidebarOpen(false)} />
      </div>
    </SmoothScrollProvider>
  );
};

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <div>Page not found</div>, // You can replace this with your custom error page if necessary
    children: [
      {
        path: "/",
        element: <div><PageLayout /></div>, // You can replace this with the main content of your home page
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <RouterProvider router={appRouter} />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
